
import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-modal';
import { jsPDF } from 'jspdf';
import { useNavigate } from "react-router-dom";

const Customer = () => {
  const [customerdata, setcustomerdata] = useState({
    name: '',
    businessName: '',
    location: '',
    phone: '',
    email: '',
    website: '',
    gstIN: ''
  });
  const [jsonData, setJsonData] = useState([

  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [alignToCenter, setAlignToCenter] = useState(true);
  const toggleAlignment = () => {
    setAlignToCenter((prevAlignToCenter) => !prevAlignToCenter);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const modalStyle = {
    content: {
      position: 'absolute',
      top: alignToCenter ? '50%' : 'auto',
      right: alignToCenter ? '50%' : 0,
      bottom: alignToCenter ? '50%' : 0,
      left: alignToCenter ? '50%' : 'auto',
      transform: alignToCenter ? 'translate(-50%, -50%)' : 'translate(0, 0)',
      margin: 0,
      height: alignToCenter ? '80%' : '80%',
      width: alignToCenter ? '40%' : '30%', // Adjusted width when centered
      borderRadius: '10px',
    },
  };
  const exportData = () => {
    const doc = new jsPDF();
    doc.text(JSON.stringify(jsonData), 10, 10);
    doc.save('data.pdf');
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setcustomerdata((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };
  const fetchCustomers = async () => {
    const res = await fetch("https://api-zspzr757qa-uc.a.run.app/orders");
    if (!res.ok) {
      throw new Error("Failed to fetch");
    }
    const data = await res.json();
    setJsonData(data);
  };

  const resetForm = () => {
    setcustomerdata({
      name: '',
      businessName: '',
      location: '',
      phone: '',
      email: '',
      website: '',
      gstIN: ''
    });
  }
  const handleaddcustomer = async () => {
    try {
      const res = await fetch("https://api-zspzr757qa-uc.a.run.app/addcustomer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerName: customerdata.customerName,
          businessName: customerdata.businessName,
          address: customerdata.address,
          phone: customerdata.phone,
          email: customerdata.email,
          website: customerdata.website,
          gstin: customerdata.gstIN
        }),
      });
      const data = await res.json();
      if (res.ok) {
        alert("Customer Added Successfully! ");
        await fetchCustomers()
        resetForm()
        closeModal(); // Close the modal on success
      } else {
        alert(`Warning: ${data.message || "Something went wrong"}`);
        resetForm()
      }
    } catch (err) {
      console.error("Error adding customer:", err);
    }
    const newData = {
      ...customerdata
    };
    await fetch("https://api-zspzr757qa-uc.a.run.app/customer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(customerdata),
    });
    fetchCustomers();//it  refresh the list
    setcustomerdata({
      name: '',
      businessName: '',
      location: '',
      phone: '',
      email: '',
      website: '',
      gstIN: ''
    });
    closeModal();
  };
  const Navigate = useNavigate()
  const handleEdit = (item) => {

    Navigate("/admin/createorder", { state: { orderData: item } });
  };
  const handleDownload = (item) => {
    if (!item.attachment) {
      alert("No file attached to this order.");
      return;
    }

    try {

      const link = document.createElement("a");
      link.href = item.attachment;
      link.download = item.attachmentName || `${item.customerName}_document`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Could not download the file.");
    }
  };
  useEffect(() => {
    fetchCustomers();
  }, []);
  return (

    <div>
      <div className="d-flex justify-content-end">
        <a className='text-success pointer' onClick={openModal}>Add New +</a>
      </div>
      <div className=" card shadow container-fluid mt-3">
        <div className="table-responsive card-body">
          <table className="table table-striped table-bordered table-hover align-middle" >

            <thead className="text-white" >
              <tr>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Name</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Business Name</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Services</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Phone</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Email</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Order Value</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Advance</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Balance</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Attachment</th>
                <th style={{ backgroundColor: '#0A1F41' }} className="text-center align-middle text-white">Actions</th>
              </tr>
            </thead>

            <tbody>
              {jsonData.map(item => (
                <tr key={item._id}>
                  <td>{item.customerName}</td>
                  <td className="text-break">{item.businessName}</td>
                  <td className="text-break">{item.service}</td>
                  <td>{item.phone}</td>
                  <td className="text-break">{item.email}</td>
                  <td className="text-center">{item.orderValue}</td>
                  <td className="text-center">{item.advance}</td>
                  <td className="text-center">{item.balance}</td>
                  <td className="text-center"><button
                    onClick={() => handleDownload(item)}
                    className={`btn btn-link ${!item.attachment ? 'text-muted' : ''}`}
                    disabled={!item.attachment}
                  >
                    {item.attachment ? "Get File 📥" : "No File"}
                  </button></td>
                  <td className="text-center"><button onClick={() => handleEdit(item)} className='btn btn-info'>Edit/Update</button></td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
      <>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Add User Modal"
          style={{
            overlay: {
              backgroundColor: "rgba(0,0,0,0.5)", // overlay handled here
            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              borderRadius: "10px",
              width: "40%",
              height: "80%",
            }
          }}
        >
          <>
            {/* <a onClick={toggleAlignment}>{alignToCenter ? <GoArrowDownRight className='arrow-icon' /> : <GoArrowUpLeft className='arrow-icon' />}</a> */}
            <a onClick={closeModal} className="d-flex justify-content-end mt-1" style={{ marginTop: '-20px' }}>
              <div className="cross" style={{ height: '20px', width: '20px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg>
              </div>
            </a>
            <h3 className="text-center bg-theme text-white mt-2 pt-1 pb-1">Add Customer</h3>
            <div className="d-flex flex-wrap justify-content-around">
              <div>
                <label htmlFor="customerName">Name</label>
                <input name='customerName' value={customerdata.customerName} onChange={handleInputChange} type="text" className='form-control' />
              </div>
              <div>
                <label htmlFor="businessName">Business Name</label>
                <input name='businessName' onChange={handleInputChange} value={customerdata.businessName} type="text" className='form-control' />
              </div>
            </div>
            <div className="d-flex flex-wrap  justify-content-around">
              <div>
                <label htmlFor="">Address</label>
                <input name='address' onChange={handleInputChange} value={customerdata.address} type="text" className='form-control' />
              </div>
              <div>
                <label htmlFor="">Phone</label>
                <input name='phone' onChange={handleInputChange} value={customerdata.phone} type="number" className='form-control' />
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-around">
              <div>
                <label htmlFor="">Email</label>
                <input name='email' onChange={handleInputChange} value={customerdata.email} type="text" className='form-control' />
              </div>
              <div>
                <label htmlFor="">Website</label>
                <input name='website' onChange={handleInputChange} value={customerdata.website} type="text" className='form-control' />
              </div>
            </div>
            <div className='ms-4'>
              <label htmlFor="">GST IN</label>
              <input name='gstIN' onChange={handleInputChange} value={customerdata.gstIN} type="text" className="form-control w-50" />
            </div>
            <button onClick={handleaddcustomer} className="btn btn-primary d-flex ms-auto">Save</button>
          </>
        </Modal>
      </>
      {/* <button className="btn btn-primary mt-2" onClick={exportData}>Export</button> */}
    </div>
  )
}

export default Customer